// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * A modal that displays a loading indicator while serial validation is in progress.
 * Shows for a minimum of 200ms to provide user feedback even for fast API responses.
 */
import { LoadingIndicator } from '@/components/navigation-layout';
import { Dialog, DialogContent, Stack, Typography } from '@mui/material';

interface Props {
  /**
   * Whether the validation modal is open.
   */
  isOpen: boolean;
}

/**
 * A modal that shows a loading indicator during serial validation.
 *
 * @param props - Configuration options for the modal
 */
export function SerialValidationModal(props: Props) {
  return (
    <Dialog open={props.isOpen} maxWidth="xs" fullWidth>
      <DialogContent>
        <Stack alignItems="center" justifyContent="center" gap={2} py={3}>
          <LoadingIndicator />
          <Typography variant="body1">Validating serials...</Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
